/** Must match `PAYMENT_METHOD_CSRF_HEADER` in `api/src/paymentMethod/paymentMethodCsrf.ts`. */
export const PAYMENT_METHOD_CSRF_HEADER = 'X-CSRF-Token';
